import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-auth-flow-selector',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './auth-flow-selector.component.html',
  styleUrl: './auth-flow-selector.component.scss'
})
export class AuthFlowSelectorComponent implements OnInit {

  private route: ActivatedRoute = inject(ActivatedRoute);

  allParams: { [key: string]: string } = {};

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      
      params.keys.forEach((key) => {
        if (key !== 'error') {
          this.allParams[key] = params.get(key) || '';
        }
      });

      if(params.has('changeAccount')) {
        console.log('changeAccount found!')
      } else {
        console.log(this.allParams)
        this.router.navigate(['/discovery'], { queryParams: { ...this.allParams } });
      }
      
    });
  }

}
